var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"d-flex"},[_c('span',{staticClass:"v-skeleton-loader__bone"})])
}
var staticRenderFns = []

export { render, staticRenderFns }